import React from "react";
import SC from "./style.js";
const TableColumnContainer = (props) => {
  const { isLoading, children } = props;
  return (
    <SC.InputContainer>
      {isLoading && (
        <SC.BlurOverlay>
          <SC.Dot></SC.Dot>
          <SC.Dot></SC.Dot>
          <SC.Dot></SC.Dot>
        </SC.BlurOverlay>
      )}
      {children}
    </SC.InputContainer>
  );
};
export default TableColumnContainer;
